import { render, staticRenderFns } from "./Wen.vue?vue&type=template&id=0270a4c2&scoped=true"
import script from "./Wen.vue?vue&type=script&lang=js"
export * from "./Wen.vue?vue&type=script&lang=js"
import style0 from "./Wen.vue?vue&type=style&index=0&id=0270a4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270a4c2",
  null
  
)

export default component.exports